import React from 'react'
import { Flex, Text } from '@radix-ui/themes'
import { EthAssetIcon } from 'shared/icons'
import { NotificationToastType } from 'shared/types'
import { TetherToken } from 'shared/ui'
import { NotificationToastTypes } from '../types'
import styles from '../notification.module.scss'

interface Props {
  notificationStateType: NotificationToastType
  winAmount: string
  winCurrency?: string | null
}

export const NotificationToastWinAmount: React.FC<Props> = ({
  notificationStateType,
  winAmount,
  winCurrency = null
}) => {
  if (
    (notificationStateType === NotificationToastTypes.WIN ||
      notificationStateType === NotificationToastTypes.LOSS ||
      notificationStateType === NotificationToastTypes.BONUS) &&
    !isNaN(Number(winAmount))
  ) {
    const winAmountText =
      winAmount.startsWith('-') ? 'You lost' : 'Your winnings are'

    const positiveAmount = Math.abs(Number(winAmount))

    const formattedWinAmount =
      (
        positiveAmount < 0.01 &&
        notificationStateType !== NotificationToastTypes.BONUS
      ) ?
        '<0.01'
      : positiveAmount

    return (
      <Flex
        align={'center'}
        gap={'2'}
      >
        <Text size={'2'}>{winAmountText}</Text>
        <WinAmountValue
          amount={formattedWinAmount}
          currency={winCurrency}
          isBonus={notificationStateType === NotificationToastTypes.BONUS}
        />
      </Flex>
    )
  }

  return null
}

interface WinAmountValueProps {
  amount: string | number
  currency: string | null
  isBonus: boolean
}

/** The amount with its token: the Tether mark for USDT, the code after the number. */
const WinAmountValue: React.FC<WinAmountValueProps> = ({
  amount,
  currency,
  isBonus
}) => (
  <Flex
    align={'center'}
    justify={'center'}
    gap={'1'}
    className={styles.winAmountContainer}
  >
    {/* TODO: Return Tether / Xyro Icon when BE will be ready*/}
    {isBonus && (
      <EthAssetIcon
        width={'2.5rem'}
        height={'2.5rem'}
      />
    )}
    {currency === 'USDT' ?
      <TetherToken
        size='2rem'
        color='yellow'
      />
    : null}
    <Text
      size={'3'}
      weight={'light'}
      className='color-white'
    >
      {amount}
      {currency ? ` ${currency}` : ''}
    </Text>
  </Flex>
)
